/**
 * Compute CRC16-CCITT (polynomial 0x1021, init 0xFFFF) over a byte buffer.
 *
 * Used as the last 2 bytes of every AstdZ payload, big-endian. Encoders append
 * it; decoders verify it. Receivers reject any payload whose computed CRC does
 * not match the trailing 2 bytes.
 *
 * @param data - The bytes to checksum (typically: full payload minus the trailing 2 CRC bytes)
 * @returns 16-bit unsigned CRC value
 */
export function crc16(data: Uint8Array): number {
  let crc = 0xFFFF;
  for (let i = 0; i < data.length; i++) {
    crc ^= (data[i]! << 8);
    for (let b = 0; b < 8; b++) {
      if ((crc & 0x8000) !== 0) {
        crc = ((crc << 1) ^ 0x1021) & 0xFFFF;
      } else {
        crc = (crc << 1) & 0xFFFF;
      }
    }
  }
  return crc & 0xFFFF;
}
